import { useEffect } from 'react';

export const useHighlightAnchors = (anchors) => {
  useEffect(() => {
    const links = anchors.map((a) =>
      document.querySelector(`aside [href='#${a}']`)
    );
    const anchorElements = anchors.map((a) => document.getElementById(a));

    const linkOffsets = anchorElements.map(({ offsetTop }) => offsetTop);

    const removeAllClasses = () => {
      for (const link of links) {
        link.classList.remove('active');
      }
    };

    const onScroll = () => {
      const windowTop = window.scrollY;

      for (let i = 0; i < linkOffsets.length; i++) {
        if (
          windowTop >= linkOffsets[i] &&
          (i === linkOffsets.length - 1 || windowTop < linkOffsets[i + 1])
        ) {
          removeAllClasses();
          links[i].classList.add('active');
          break;
        } else {
          removeAllClasses();
        }
      }
    };

    document.addEventListener('scroll', onScroll);

    return () => {
      document.removeEventListener('scroll', onScroll);
    };
  }, []);
};
